import { render, staticRenderFns } from "./sideLayout.vue?vue&type=template&id=2434202d&scoped=true&"
import script from "./sideLayout.vue?vue&type=script&lang=js&"
export * from "./sideLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434202d",
  null
  
)

export default component.exports